export default {
  'server': {
    'action': {
      'created': 'Created',
      'accepted': 'Accepted',
    },
    'common': {
      'successed': 'Successed',
      'error': 'Something went wrong',
      'existed-code': 'Code already exist!',
      'wrong-action': 'Wrong action',
      'permission-denied': 'Permission denied',
      'invalid-duration': 'Duration value is invalid',
      'invalid-expired-date': 'Expired date is invalid',
      'request-processed': 'Request is aprroved or cancelled',
      'wrong-password': 'Incorrect password',
      'reached-maximum-sms': 'Reach maximum SMS messages',
      'send-email-failed': 'Send email failed, please try again later',
      'not-found': 'Information not found',
      'invalid-data': 'Invalid data',
      'is-expired': 'Is expired',
      'reached-maximum': 'Reached maximum number allow',
      'phone-existed': 'Phone already exists',
      'email-not-existed': 'Email is not existed',
      'wrong-email-format': 'Incorrect email format',
      'incorrect-old-password': 'Old password is not correct'
    },
    'account': {
      'not-register': 'You have not registered, please register',
      'not-actived': 'Account is not actived',
      'is-deleted': 'Account is deleted',
      'already-exist': 'Account or email already exists',
      'already-linked-google': 'The google account is already linked to another account',
      'already-linked-facebook': 'The facebook account has been linked to another account',
      'not-found-google': 'Your google account was not registered',
      'not-found-facebook': 'Your facebook account was not registered',
      'registered-google': 'This google account has been registered already.',
      'not-allow-customer': 'Customer cannot login',
      'entity-disabled': 'Your account management supplier has not been activated or locked',
      'required-report-role': 'Please login with a reporter account',
      'confirm-reused-deleted': 'This account has been deleted do you want to recover?',
    },
    'entity': {
      'is-disabled': 'This entity has been disabled!',
      'already-in-supplier': 'Account has been in Supplier already, you cannot register more',
      'cannot-delete-supplier': 'Cannot delete supplier is exist agent delegacy',
      'forced-create': 'This entity has been deleted do you want to recover?',
      'not-under-subordinate-level': 'This agent is not under your subordinate level',
      'reached-maximum-agent': 'Number of agents has reached maximum',
      'site-existing': 'The site already exists in the region',
      'supplier-email-already-used': 'Supplier email already used in another supplier',
      'reached-maximum-user': 'The number of users exceeds the allowed',
    },
    'merchant': {
      'invalid-code': 'Invalid merchant code',
    },
    'voucher': {
      'wrong-activation-code': 'Activation code is invalid',
      'cannot-delete-distributed': 'The issue for which the voucher was distributed cannot be deleted',
      'cannot-update-distributed': 'The issue for which the voucher was distributed cannot be edited',
      'cannot-print-unpublished': 'Unpublished printing vouchers cannot be printed',
      'reached-number-quantity': 'The number of vouchers must not be less than the created quantity of ',
      'been-issued': 'Voucher has been delivered',
      'is-invalid': 'This voucher is deleted or disabled',
      'has-used': 'Voucher has been used',
      'has-issued': 'Voucher has been issued',
      'is-disabled': 'Voucher has been disabled',
      'is-expired': 'Voucher is expired',
      'invalid-usage-time': 'Voucher has not been used yet',
      'cannot-used': 'This voucher cannot be used!',
      'undistributed': 'Voucher has not been distributed to customers',
      'not-exist-vouchers': 'There are vouchers that do not exist in the system',
      'incorrect-activation-code': 'Activation code is incorrect',
      'activion-code-unavaiable': 'Active code does not exist',
      'quantity-limited': 'The number of uses exceeded the limit',
      'activion-code-expired': 'The activation code has expired',
      'not-found': 'No voucher found',
      'issuance': {
        'not-existed': 'The issuance is not exist',
        'is-expired': 'This expired voucher is for distribution',
        'invalid-quantity': 'The amount entered exceeds the available quantity',
        'confirm-create-with-existing': 'The {prefix} - {suffix} issuance already exists. Please select confirm if you want to use this issuance?',
      },
      'transaction': {
        'cannot-transfer-yourself': 'Cannot transfer to yourself',
        'from-entity-not-exist': 'Outgoing agent does not exist',
        'to-entity-not-exist': 'Agent to transfer does not exist',
        'has-no-parent': 'Entity has no parent',
        'not-same-parent': 'The agents are not the same level of parent',
        'not-own-voucher': 'You no longer own this voucher',
        'out-of-available': 'The number of vouchers to be transferred exceeds the number of vouchers available',
        'exist-non-transferable': 'Non-transferable voucher exists',
        'non-transferable': 'This voucher is non-transferable',
        'exist-used-vouchers': 'There exist vouchers that have been used',
        'is-used-voucher': 'This voucher has already been used',
        'exist-confimation-vouchers': 'There are vouchers waiting for confirmation to be used',
        'cannot-transfer-confirmation-voucher': 'Vouchers awaiting confirmation of use cannot be delivered',
        'exist-expired-vouchers': 'Existing expired voucchers',
        'voucher-expired': 'Cannot transfer expired voucher',
        'is-expired-or-distributed': 'Voucher is expired or distributed',
        'exist-unlocked-vouchers': 'Has vouchers which is not LOCKED USING state',
      },
      'approval': {
        'not-permission': 'You has no permission to approve this request',
        'request-cancelled': 'Request has been cancelled',
        'has-approved': 'Request has been approved',
      },
      'reconciliation': {
        'cannot-process-approved': 'Can not process the reconciled voucher',
        'was-approved': 'The voucher reconciliation has been approved',
        'not-found': 'No voucher found for reconsillation',
        'was-reconciled': 'Existing reconciled voucher in list',
      },
      'promotion': {
        'not-existed': 'Voucher code does not exist',
        'has-expired': 'This promotional voucher has expired!',
        'out-of-usage-times': 'You have run out of usage times',
        'code-not-existed': 'Promotion code not exists',
        'code-expired': 'Promotion code expired',
        'code-existed': 'Promotion code already exists',
        'reached-usage-times': 'Mã khuyến mãi đã hết số lần sử dụng',
      },
      'product': {
        'reach-maximum-quantity': 'The number of vouchers to purchase exceeds the available quantity',
        'reach-maximum-upload': 'The number of vouchers to upload to portal exceeds the available quantity',
        'reach-maximum-remove': 'The number of vouchers to be removed exceeds the amount posted',
        'active-key-existed': 'Active key already exist',
        'domain-existed': 'Domain already exists',
        'domain-in-used': 'Domain already used by another agent',
        'verification-code-unavailable': 'Verification code is not available',
        'verification-code-expired': 'Verification code has expired',
        'agent-code-invalid': 'Agent code is invalid',
        'email-domain-unavailable': 'Email domain unavailable',
        'incorrect-account': 'Incorrect account',
        'catalog-code-existed': 'Catalog code is existing',
        'out-of-purchase': 'You have run out of purchases for this product',
        'missing-activate-key': 'Active key is required',
        'invalid-order-code': 'Invalid order code',
        'cart': {
          'over-quantity': 'Reached maximum voucher quantity in store',
        }
      }
    },
    'usage': {
      'path-expired': 'Comfirmation path is expired',
      'path-not-exist': 'Confirmation path is unavailable',
    }
  }
}
